// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/assets/images/homePage/poker-overlay.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --white: #ffffff;
  --white-015: rgba(255, 255, 255, 0.15);
  --black: #000000;
  --black900: #080F16;
  --lightkGray: #A4A4A4;
  --gray: #879096;
  --light-gray: rgba(130, 154, 181, 1);
  --theme-dark: #162331;
  --theme-secondary: #2c4158;
  --theme-border: #25394F;
  --secondry-border: rgba(255, 255, 255, 0.28);
  --primaryBtn: #162331;
  --primaryBtnHover: linear-gradient(to right, rgba(33, 168, 247, 1) 0%, rgba(53, 179, 249, 1) 100%);
  --secondaryBtn: linear-gradient(to right, rgba(33, 168, 247, 1) 0%, rgba(53, 179, 249, 1) 100%);
  --secondaryRadialBtn: linear-gradient(90deg, #F9E46D 0%, #C78C26 100%);
  --secondaryRadialBtnLhover: linear-gradient(90deg, #C78C26 0%, #F9E46D 100%);
  --secondaryBtnBorder: rgba(255, 255, 255, 0.45);
  --primaryBtnBorder: #1B9FFB;
  --authTabActiveBorder: #c69c53;
  --headerBtnHover: #404D6A;
  --placeBetBase: #0373b5;
  --tipBtnBg: #26384B;
  --authTabActiveBtnBg: #303F50;
  --authTabBtn: #202F3F;
  --moneTabsBtn: #26374A;
  --authTabBtnText: #8A90A2;
  --authSocailColor: #344051;
  --authSocailTextColor: #6B758B;
  --currencyHover: #1C2B3B;
  --cryptoDetailsBtn: #587594;
  --sidebarTooltip: #283C51;
  --primaryGradient: linear-gradient(90deg, #283C51 0%, rgba(22, 35, 49, 0.00) 100%);
  --detailsBorder: #283C52;
  --inputbg: #121C27;
  --inputBorder: #223244;
  --chatModalBorder: #445d799b;
  --chatModalClose: #2C3F54;
  --weekBg: #1B2A39;
  --themeCardTopGradient: linear-gradient(180deg, rgba(68, 94, 122, 1) 0%, rgba(37, 57, 79, 0)100%);
  --themeCard: #213143;
  --sidebarMenuBg: linear-gradient(180deg, #162331 0%, #1F3246 100%);
  --liveMatchCountBg: linear-gradient(180deg, #273A4D 0%, #1A2835 100%);
  --liveMatchCountBorder: rgba(255, 255, 255, 0.04);
  --liveGreen: #72F238;
  --profitBg: #2A3C2F;
  --headingLink: #F9E46D;
  --primaryBtnText: #B0E3FD;
  --sidebarHover: #75cdff;
  --inputBoxShadowOne: rgb(45 174 247);
  --inputBoxShadowTwo: rgb(72 177 251);
  --slider-btnBorder: #24364A;
  --gameOnGradient: linear-gradient(180deg, #FFEBA9 0%, #E4B863 100%);
  --loss: #FF3636;
  --cryptoSellBtn: rgb(255, 73, 73);
  --cryptoSellBtnBg: rgba(255, 73, 73, 0.13);
  --cryptoSliderBg: linear-gradient(90deg, rgb(114, 242, 56) 0%, rgb(255, 176, 24) 50%, rgb(255, 73, 73) 100%);
  --darkGray: #0F1923;
  --table-fade: linear-gradient(to bottom, rgba(30, 87, 153, 0.01) 0%, rgba(15, 25, 35, 1) 100%);
  --nft-badge: #223345;
  --footerBorder: #323B45;
  --cryptoDetailBtn: #263648;
  --footerBg: #142230;
  --selectBg: rgba(49, 58, 66, 0.50);
  --footerLinking: #0F1B26;
  --socialLinksBg: #1E2D3D;
  --overlayBg: rgb(23 37 54 / 91%);
  --webBannerOverlay: linear-gradient(90deg, #15222F -0.86%, rgba(15, 25, 35, 0.70) 18.12%, rgba(15, 25, 35, 0.00) 38.19%);
  --authPrimryBtn: radial-gradient(90.91% 90.91% at 50.00% 9.09%, #1B2A3C 0%, #131F2D 100%);
  --providerCard: linear-gradient(223deg, #162331 0%, #111D28 100%);
  --profileMenuTop: #1E2F41;
  --profileMenuBorder: #293C51;
  --profileHover: #111C27;
  --profileCard: #182533;
  --profileCardBorder: #283A4E;
  --statusColorOne: #BE6BFF;
  --profileSocialBg: #1D2B3B;
  --profileOutlineBtn: #080E14;
  --cryptoText: #90B4D9;
  --sidebarBtnGradient: linear-gradient(270deg, #0096FF -1.3%, #48BDFF 99.93%);
  --loaderBg: rgb(15 25 35 / 85%);
  --chatIcon: #829AB5;
  --chatText: #AAB6CF;
  --chatUserOne: #9F735C;
  --chatCardBg: #283C5180;
  --languagetext: #8A90A2;
  --tipAmountText: #eb9b29;
  --textGradientOne: linear-gradient(90deg, #526FFF 0%, #9CACFF 90.91%);
  --textGradientTwo: linear-gradient(90deg, #36CAC5 0%, #8FFFEE 38.87%);
  --textGradientThree: linear-gradient(270deg, #C776FF 8.01%, #A331F1 100%);
  --ecosystemLinkOne: #5270FF;
  --ecosystemLinkTwo: #3CCDC7;
  --ecosystemLinkThree: #AE55ED;
  --homePromotinBadge: #15212E;
  --staticText: #636D82;
  --listitemtext: #E7E7E7;
  --dropdownShadow: 0px 0px 16px 0px #0F1923F5;
  --cardBgBox: #1D2C3C;
  --dragtextBg: #0F192366;
  --userreportBg: #1f3140;
  --previewBg: #283c51e0;
  --rewardsBannerBg: rgb(23 37 54 / 75%);
  --wildrange: #FF007A;
  --sliderGradient: linear-gradient(90deg, #0493ED 0.9%, #810CFF 33.25%, #FD2E6E 100%);
  --mineTableCellBg01: #32465C;
  --mineTableCellBg02: #203041;
  --mineTableCellCoinBg01: #182935;
  --mineTableCellCoinBg02: #76C5FF;
  --mineTableCellCoinBg03: #0068B4;
  --mineTableCellMineBg01: #7976FF;
  --mineTableCellMineBg02: #4F1AC1;
  --mineTableCellBorder01: #49617C;
  --mineTableCellBorder02: #3BABFC;
  --mineTableCellBorder03: #793BFC;
  --btnBgGreyHover: #3d5564;
  --minePlachholder: #657D97;
  --red: #FF0000;
  --green: #00e701;
  --themeGreyText: #30475F;
  --gameKenoSlenderBg: linear-gradient(rgba(20, 20, 20, 0.99), rgba(20, 20, 20, 0.99)),
    linear-gradient(90deg, rgba(255, 255, 255, 0.20) 0.95%, rgba(255, 255, 255, 0.01) 50%, rgba(255, 255, 255, 0.20) 100%);
  --gameKenoNumberCell: linear-gradient(rgba(20, 20, 20, 0.99), rgba(20, 20, 20, 0.99)),
    linear-gradient(90deg, rgba(255, 255, 255, 0.25) 0.95%, rgba(255, 255, 255, 0.06) 50%, rgba(255, 255, 255, 0.25) 100%);
  --gameKenoNumberGridBg: linear-gradient(rgba(20, 20, 20, 0.99), rgba(20, 20, 20, 0.99)),
    linear-gradient(90deg, rgba(255, 255, 255, 0.20) 0%, rgba(255, 255, 255, 0.20) 30%, rgba(255, 255, 255, 0.01) 50%, rgba(255, 255, 255, 0.20) 70%, rgba(255, 255, 255, 0.20) 100%);
  --gameKenoNumberGridChangeBorder: linear-gradient(rgba(20, 20, 20, 0.99), rgba(20, 20, 20, 0.99)),
    linear-gradient(133.45deg, #FFF1AB 24.75%, #FFDA24 46.17%, #FFC81D 54.03%, #FF9A0C 70.45%, #FF7700 81.88%);
  --gameKenoNumberGridSelectedBg: linear-gradient(36.57deg, #FFFFFF 54.8%, #FBE9CF 97.25%), linear-gradient(0deg, #FFFFFF, #FFFFFF);
  --kenoBtnShadow: 0px 9px 7.099999904632568px 0px #FFFFFF7A inset, 0px -2px 10px 0px #000000 inset, 0px 9px 7.099999904632568px 0px #FFFFFF7A inset, 0px -2px 10px 0px #000000 inset;
  --kenoSelectedNumberShadow: 0px -4.182754039764404px 5.228443145751953px 0px #6C6C6C inset;
  box-shadow: 0px 4.1827540398px 4.1827540398px 0px rgba(0, 0, 0, 0.2509803922);
  --riskBtnBg: #1B2938;
  --riskBtnBorder: #213142;
  --rangeSliderTrack: #23374C;
  --flip-coin-text: rgba(34, 32, 32, 0.85);
  --flip-coin-gradient: linear-gradient(93.45deg, #FF7A00 0%, #9CE800 139.58%);
  --flip-coin-bg: radial-gradient(92.09% 85.42% at 86.3% 87.5%, rgba(0, 0, 0, 0.23) 0%, rgba(0, 0, 0, 0) 86.18%), #F6C100;
  --hoverBorder: #78CDFD;
  --card-bg: #7EFF43;
  --containerBg: #162331;
  --containerBorder: #26384b;
  --game-primary: #21A8F7;
  --game-color-100: #111B26;
  --game-color-200: #1F2E3E;
  --game-color-300: #131D28;
  --game-color-400: #26374A;
  --game-color-500: #1B2938;
  --game-color-600: #0F1923;
  --game-color-700: #32465C;
  --game-color-800: #203041;
  --game-color-900: #151E28;
  --game-text-100: #657D97;
  --game-text-200: #90B4D9;
  --game-text-300: #526C88;
  --game-border-100: #25394F;
  --game-border-200: #213142;
  --game-border-300: #465D77;
  --game-border-400: #212D3A;
  --game-border-500: #30475F;
  --flip-coin-game-border: rgba(68, 94, 122, 0.5);
  --range-slider-bg-800: #182534;
  --flip-coin-checkbox-border: #192837;
  --flip-coin-selctbox: #223346;
  --flip-coin-addon-btn-bg: #1F2E3F;
  --rangeSliderBg1: #0C8BEE;
  --rangeSliderBg2: #F82C74;
  --black-700: #482E00;
  --grey-700: #203143;
}

.home-sports-section {
  padding-bottom: 1.875rem;
}
.home-sports-section .theme-card-wrap {
  transition: transform 0.15s ease-out 0s;
}
.home-sports-section .theme-card-wrap:hover {
  transform: translateY(-8px);
}
.home-sports-section .slick-track {
  padding: 0.625rem 0 0;
}
.home-sports-section .theme-card {
  text-align: center;
  min-height: 156px;
  cursor: pointer;
}
.home-sports-section .theme-card h4 {
  color: var(--white);
  font-weight: 700;
  font-family: "Teko", sans-serif;
  font-size: 1.125rem;
  line-height: 1.25rem;
}
.home-sports-section .theme-card svg {
  margin: 1.5rem auto;
  height: 36px !important;
  width: 36px !important;
}
.home-sports-section .theme-card .live-game-icon {
  margin: 1.5rem auto;
}
.home-sports-section .live-match-count-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
}
.home-sports-section .live-match-count {
  background: var(--liveMatchCountBg);
  box-shadow: 0px 2px 5px 0px rgba(9, 27, 45, 0.47);
  border-radius: 22px;
  border: 1px solid var(--liveMatchCountBorder);
  padding: 0 1rem;
  min-height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 1rem auto 0;
  color: var(--white);
  position: absolute;
  bottom: 1.5rem;
}
.home-sports-section .live-match-count .live-dot {
  background: var(--liveGreen);
  height: 8px;
  width: 8px;
  border-radius: 100%;
  display: block;
  margin-right: 0.313rem;
}
.home-sports-section .live-match-count p {
  font-size: 0.875rem;
  font-weight: 500;
}

.crypto-section {
  padding-bottom: 1.875rem;
}
.crypto-section .theme-card-wrap {
  transition: transform 0.15s ease-out 0s;
  cursor: pointer;
}
.crypto-section .theme-card-wrap .theme-card {
  overflow: hidden;
  min-height: 202px;
  position: relative;
}
.crypto-section .theme-card-wrap .theme-card .trade-header {
  padding: 0 0.625rem;
}
.crypto-section .theme-card-wrap .theme-card .trade-header p {
  font-size: 12px;
  color: var(--authSocailTextColor);
  font-weight: 600;
  margin: 0;
}
.crypto-section .theme-card-wrap .theme-card .trade-header .tarde-logo {
  margin-right: 0.313rem;
  height: 1.875rem;
  width: 1.875rem;
}
.crypto-section .theme-card-wrap .theme-card .trade-card-content {
  color: #ffffff;
  padding: 0 0.625rem;
}
.crypto-section .theme-card-wrap .theme-card .trade-card-content .crypto-list-right span {
  font-size: 14px;
  font-weight: 700;
}
.crypto-section .theme-card-wrap .theme-card .trade-card-content h4 {
  font-weight: 600;
  margin: 0;
  font-size: 0.875rem;
}
.crypto-section .theme-card-wrap .theme-card h4 {
  color: var(--white);
  font-size: 14px;
  font-weight: 700;
  margin: 0;
}
.crypto-section .theme-card-wrap .theme-card .tarde-graph-wrap {
  position: absolute;
  bottom: -20px;
  width: 100%;
}
.crypto-section .theme-card-wrap .theme-card .tarde-graph-wrap img {
  width: 100%;
  height: 100%;
}
.crypto-section .theme-card-wrap .theme-card .tarde-graph-wrap .tarde-graph-text {
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  bottom: 0.625rem;
  width: 100%;
}
.crypto-section .theme-card-wrap .theme-card .tarde-graph-wrap .tarde-graph-text p {
  color: var(--white);
  font-size: 0.75rem;
  font-weight: 400;
  text-align: center;
  padding: 0 0.313rem;
}
.crypto-section .theme-card-wrap:hover {
  transform: translateY(-8px);
}
.crypto-section .loss-value {
  color: var(--loss);
  font-size: 0.75rem;
  font-weight: 500;
  margin: 0;
}
.crypto-section .loss-value img {
  margin-right: 0.313rem;
}
.crypto-section .profit-value {
  color: var(--liveGreen);
  font-size: 0.75rem;
  font-weight: 500;
  margin: 0;
}
.crypto-section .profit-value img {
  margin-right: 0.313rem;
}
.crypto-section .tarde-graph-text h4 {
  font-weight: 300;
  font-size: 0.75rem;
}
.crypto-section .tarde-graph-text p {
  font-weight: 400;
  line-height: 0.75rem;
}
.crypto-section .slick-track {
  padding: 0.625rem 0 0;
}
.crypto-section .Info-icon img {
  width: 1rem;
}

.loss-change {
  font-size: 12px;
  font-weight: 600;
  padding: 0 0.625rem;
  color: var(--loss);
}

.profit-change {
  font-size: 12px;
  font-weight: 600;
  padding: 0 0.625rem;
  color: var(--liveGreen);
}

.slide-wrap .slick-slide .px-06 {
  padding-right: 0.75rem;
}
.slide-wrap .slick-list {
  width: calc(100% + 10px);
}

.clutch-section {
  padding-bottom: 1.875rem;
}
.clutch-section .clutch-header {
  display: flex;
  align-items: center;
}
.clutch-section .clutch-header img {
  margin-right: 0.615rem;
}
.clutch-section .clutch-header h4 {
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--white);
}
.clutch-section .slick-track {
  padding: 0.625rem 0 0;
}
.clutch-section .theme-card-wrap {
  cursor: pointer;
  transition: transform 0.15s ease-out 0s;
}
.clutch-section .theme-card-wrap .theme-card {
  padding: 1.5rem;
}
@media screen and (max-width: 767.98px) {
  .clutch-section .theme-card-wrap .theme-card {
    padding: 1rem 0.625rem;
  }
}
.clutch-section .theme-card-wrap .theme-card p {
  color: var(--authTabBtnText);
  font-size: 0.75rem;
  font-weight: 400;
  padding-top: 0.625rem;
  line-height: 1rem;
}
@media screen and (max-width: 767.98px) {
  .clutch-section .theme-card-wrap .theme-card p {
    padding-top: 0.313rem;
  }
}
.clutch-section .theme-card-wrap .theme-card .clutch-card-content {
  padding: 1rem 0 0;
}
.clutch-section .theme-card-wrap .theme-card .clutch-card-content h4 {
  color: var(--white);
  font-size: 0.813rem;
  font-weight: 500;
  line-height: 1rem;
}
.clutch-section .theme-card-wrap .theme-card .clutch-card-content h4 a {
  color: var(--authSocailTextColor);
  font-size: 0.813rem;
  font-weight: 400;
}
.clutch-section .theme-card-wrap .theme-card .clutch-card-content .clutch-card-content-left img {
  margin-right: 0.625rem;
}
.clutch-section .theme-card-wrap .theme-card .clutch-card-content .btn-secondary {
  font-size: 0.75rem;
  height: 1.875rem;
  min-width: 5.813rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.clutch-section .theme-card-wrap:hover {
  transform: translateY(-8px);
}

.poker-section {
  padding-bottom: 1.875rem;
}
.poker-section .theme-card-wrap {
  cursor: pointer;
  transition: transform 0.15s ease-out 0s;
}
.poker-section .theme-card-wrap .theme-card {
  position: relative;
  min-height: 200px;
}
.poker-section .theme-card-wrap .theme-card:before {
  position: absolute;
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background-repeat: no-repeat;
  background-size: cover;
}
.poker-section .theme-card-wrap .theme-card h4 {
  color: var(--white);
  font-weight: 700;
  font-family: "Teko", sans-serif;
  font-size: 1.2rem;
  line-height: 1.8rem;
  text-align: center;
  margin: 0;
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .poker-section .theme-card-wrap .theme-card h4 {
    font-size: 1.2rem;
  }
}
.poker-section .theme-card-wrap .theme-card p {
  text-align: center;
  color: var(--authTabBtnText);
  font-size: 0.75rem;
  margin: 0;
}
.poker-section .theme-card-wrap .theme-card .poker-card-content {
  position: relative;
}
.poker-section .theme-card-wrap .theme-card .poker-card-content .poker-icon {
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.poker-section .theme-card-wrap .theme-card .poker-card-content img {
  margin: 0 auto;
}
.poker-section .theme-card-wrap:hover {
  transform: translateY(-8px);
}
.poker-section .slick-track {
  padding: 0.625rem 0 0;
}

.nft-section {
  padding-bottom: 1.875rem;
}
.nft-section .theme-card-wrap {
  cursor: pointer;
  transition: transform 0.15s ease-out 0s;
}
.nft-section .theme-card-wrap .theme-card .nft-img-wrap {
  position: relative;
  overflow: hidden;
  border-radius: 0.625rem;
}
.nft-section .theme-card-wrap .theme-card .nft-img-wrap img {
  width: 100%;
}
.nft-section .theme-card-wrap .theme-card .nft-img-wrap .nft-badge {
  position: absolute;
  padding: 0 0.313rem;
  border-radius: 27px;
  background: var(--nft-badge);
  min-height: 26px;
  min-width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white);
  font-size: 0.625rem;
  font-weight: 600;
  left: 0.313rem;
  top: 0.313rem;
}
.nft-section .theme-card-wrap .theme-card .nft-content-wrap {
  padding: 0.313rem 0;
}
.nft-section .theme-card-wrap .theme-card .nft-content-wrap .nft-content-left h4 {
  color: var(--white);
  font-size: 1rem;
  font-weight: 600;
}
.nft-section .theme-card-wrap .theme-card .nft-content-wrap .nft-content-left p {
  color: var(--authTabBtnText);
  margin: 0;
  font-size: 0.875rem;
}
.nft-section .theme-card-wrap .theme-card .nft-content-wrap .nft-content-right span {
  color: var(--authTabBtnText);
  font-size: 0.75rem;
}
.nft-section .theme-card-wrap:hover {
  transform: translateY(-8px);
}
.nft-section .slick-track {
  padding: 0.625rem 0 0;
}

.crypto-won-section {
  padding-bottom: 1.5rem;
  text-align: center;
}
.crypto-won-section .payment-options a {
  padding: 0 0.625rem;
  display: inline-block;
}
@media screen and (max-width: 767.98px) {
  .crypto-won-section .payment-options a {
    padding: 0;
  }
}
.crypto-won-section .payment-options a img {
  width: auto;
  height: 1.813rem;
}
@media screen and (max-width: 1399.98px) {
  .crypto-won-section .payment-options a img {
    height: 1.5rem;
  }
}
@media screen and (max-width: 767.98px) {
  .crypto-won-section .payment-options a img {
    height: 1.25rem;
  }
}
.crypto-won-section .payment-options.flexible-section a {
  padding: 0 1rem;
}
@media screen and (max-width: 767.98px) {
  .crypto-won-section .payment-options svg, .crypto-won-section .payment-options img {
    width: 45px;
    margin: 0 3px;
  }
}
.crypto-won-section h3 {
  color: var(--white);
  font-size: 1.25rem;
  line-height: 1.5rem;
  font-weight: 700;
}
@media screen and (max-width: 1399.98px) {
  .crypto-won-section h3 {
    font-size: 1.125rem;
  }
}
@media screen and (max-width: 1199.98px) {
  .crypto-won-section h3 {
    font-size: 1.125rem;
  }
}
@media screen and (max-width: 991.98px) {
  .crypto-won-section h3 {
    margin-bottom: 1rem !important;
  }
}
@media screen and (max-width: 767.98px) {
  .crypto-won-section h3 {
    font-size: 1rem;
    margin-bottom: 0.5rem !important;
  }
}
.crypto-won-section .theme-card {
  padding: 0.3rem 2rem;
  position: relative;
}
@media screen and (max-width: 767.98px) {
  .crypto-won-section .theme-card {
    text-align: center;
    padding: 1rem;
  }
}
@media screen and (max-width: 767.98px) {
  .crypto-won-section .btn-secondary {
    width: 100%;
    min-width: 100px;
    min-height: 40px;
    font-size: 0.75rem;
    margin-top: 0.625rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/sass/_variables.scss","webpack://./src/pages/Home/home.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,sCAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,oCAAA;EACA,qBAAA;EACA,0BAAA;EACA,uBAAA;EACA,4CAAA;EACA,qBAAA;EACA,kGAAA;EACA,+FAAA;EAEA,sEAAA;EAEA,4EAAA;EAEA,+CAAA;EACA,2BAAA;EACA,8BAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,yBAAA;EACA,0BAAA;EACA,8BAAA;EACA,wBAAA;EACA,2BAAA;EACA,yBAAA;EACA,kFAAA;EACA,wBAAA;EACA,kBAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;EACA,iBAAA;EACA,iGAAA;EACA,oBAAA;EACA,kEAAA;EACA,qEAAA;EACA,iDAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,uBAAA;EACA,oCAAA;EACA,oCAAA;EACA,2BAAA;EACA,mEAAA;EACA,eAAA;EACA,iCAAA;EACA,0CAAA;EACA,4GAAA;EACA,mBAAA;EACA,8FAAA;EACA,oBAAA;EACA,uBAAA;EACA,0BAAA;EACA,mBAAA;EACA,kCAAA;EACA,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,wHAAA;EACA,yFAAA;EACA,iEAAA;EACA,yBAAA;EACA,4BAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;EACA,0BAAA;EACA,4BAAA;EACA,qBAAA;EACA,4EAAA;EACA,+BAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,qEAAA;EACA,qEAAA;EACA,yEAAA;EACA,2BAAA;EACA,2BAAA;EACA,6BAAA;EACA,4BAAA;EACA,qBAAA;EACA,uBAAA;EACA,4CAAA;EACA,oBAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,sCAAA;EACA,oBAAA;EACA,oFAAA;EAEA,4BAAA;EACA,4BAAA;EACA,gCAAA;EACA,gCAAA;EACA,gCAAA;EACA,gCAAA;EACA,gCAAA;EACA,gCAAA;EACA,gCAAA;EACA,gCAAA;EACA,yBAAA;EACA,0BAAA;EACA,cAAA;EACA,gBAAA;EACA,wBAAA;EAGA;0HAAA;EAEA;0HAAA;EAEA;qLAAA;EAEA;8GAAA;EAEA,iIAAA;EACA,mLAAA;EACA,0FAAA;EACA,6EAAA;EAGA,oBAAA;EACA,wBAAA;EACA,2BAAA;EAGA,wCAAA;EACA,4EAAA;EACA,uHAAA;EAIA,sBAAA;EACA,kBAAA;EAGA,sBAAA;EAEA,0BAAA;EAEA,uBAAA;EAEA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EAEA,wBAAA;EACA,wBAAA;EACA,wBAAA;EAEA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,0BAAA;EAGA,+CAAA;EACA,8BAAA;EACA,oCAAA;EACA,6BAAA;EACA,iCAAA;EACA,yBAAA;EACA,yBAAA;EAIA,oBAAA;EACA,mBAAA;ACxBF;;AAvKA;EACE,wBAAA;AA0KF;AAxKE;EACE,uCAAA;AA0KJ;AAxKI;EACE,2BAAA;AA0KN;AAtKE;EACE,qBAAA;AAwKJ;AArKE;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;AAuKJ;AArKI;EACE,mBAAA;EACA,gBAAA;EACA,+BAAA;EACA,mBAAA;EACA,oBAAA;AAuKN;AApKI;EACE,mBAAA;EACA,uBAAA;EACA,sBAAA;AAsKN;AAnKI;EACE,mBAAA;AAqKN;AAjKE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAmKJ;AAhKE;EACE,mCAAA;EACA,iDAAA;EACA,mBAAA;EACA,6CAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAkKJ;AAhKI;EACE,4BAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;AAkKN;AA/JI;EACE,mBAAA;EACA,gBAAA;AAiKN;;AA5JA;EACE,wBAAA;AA+JF;AA7JE;EACE,uCAAA;EACA,eAAA;AA+JJ;AA7JI;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;AA+JN;AA7JM;EACE,mBAAA;AA+JR;AA7JQ;EACE,eAAA;EACA,iCAAA;EACA,gBAAA;EACA,SAAA;AA+JV;AA5JQ;EACE,sBAAA;EACA,gBAAA;EACA,eAAA;AA8JV;AA1JM;EACE,cAAA;EACA,mBAAA;AA4JR;AA1JQ;EACE,eAAA;EACA,gBAAA;AA4JV;AAzJQ;EACE,gBAAA;EACA,SAAA;EACA,mBAAA;AA2JV;AAvJM;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAyJR;AAtJM;EACE,kBAAA;EACA,aAAA;EACA,WAAA;AAwJR;AAtJQ;EACE,WAAA;EACA,YAAA;AAwJV;AArJQ;EACE,kBAAA;EACA,SAAA;EACA,gCAAA;EACA,gBAAA;EACA,WAAA;AAuJV;AArJU;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAuJZ;AAjJI;EACE,2BAAA;AAmJN;AA/IE;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;AAiJJ;AA/II;EACE,sBAAA;AAiJN;AA7IE;EACE,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;AA+IJ;AA7II;EACE,sBAAA;AA+IN;AA1II;EACE,gBAAA;EACA,kBAAA;AA4IN;AAzII;EACE,gBAAA;EACA,oBAAA;AA2IN;AAvIE;EACE,qBAAA;AAyIJ;AArII;EACE,WAAA;AAuIN;;AAlIA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAqIF;;AAlIA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAqIF;;AAhII;EACE,sBAAA;AAmIN;AA/HE;EACE,wBAAA;AAiIJ;;AA9HA;EACE,wBAAA;AAiIF;AA/HE;EACE,aAAA;EACA,mBAAA;AAiIJ;AA/HI;EACE,sBAAA;AAiIN;AA9HI;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAgIN;AA5HE;EACE,qBAAA;AA8HJ;AA3HE;EACE,eAAA;EACA,uCAAA;AA6HJ;AA3HI;EACE,eAAA;AA6HN;AA3HM;EAHF;IAII,sBAAA;EA8HN;AACF;AA5HM;EACE,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;AA8HR;AA5HQ;EAPF;IAQI,qBAAA;EA+HR;AACF;AA5HM;EACE,iBAAA;AA8HR;AA5HQ;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AA8HV;AA5HU;EACE,iCAAA;EACA,mBAAA;EACA,gBAAA;AA8HZ;AAzHU;EACE,sBAAA;AA2HZ;AAvHQ;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAyHV;AApHI;EACE,2BAAA;AAsHN;;AAjHA;EACE,wBAAA;AAoHF;AAlHE;EACE,eAAA;EACA,uCAAA;AAoHJ;AAlHI;EACE,kBAAA;EACA,iBAAA;AAoHN;AAlHM;EACE,kBAAA;EACA,WAAA;EACA,mDAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,4BAAA;EACA,sBAAA;AAoHR;AAjHM;EACE,mBAAA;EACA,gBAAA;EACA,+BAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AAmHR;AAjHQ;EATF;IAUI,iBAAA;EAoHR;AACF;AAjHM;EACE,kBAAA;EACA,4BAAA;EACA,kBAAA;EACA,SAAA;AAmHR;AAhHM;EACE,kBAAA;AAkHR;AAhHQ;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAkHV;AA/GQ;EACE,cAAA;AAiHV;AA5GI;EACE,2BAAA;AA8GN;AA1GE;EACE,qBAAA;AA4GJ;;AAxGA;EACE,wBAAA;AA2GF;AAzGE;EACE,eAAA;EACA,uCAAA;AA2GJ;AAxGM;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;AA0GR;AAxGQ;EACE,WAAA;AA0GV;AAvGQ;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;AAyGV;AArGM;EACE,mBAAA;AAuGR;AApGU;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;AAsGZ;AAnGU;EACE,4BAAA;EACA,SAAA;EACA,mBAAA;AAqGZ;AAhGU;EACE,4BAAA;EACA,kBAAA;AAkGZ;AA5FI;EACE,2BAAA;AA8FN;AA1FE;EACE,qBAAA;AA4FJ;;AAxFA;EACE,sBAAA;EACA,kBAAA;AA2FF;AA3EI;EACE,mBAAA;EACA,qBAAA;AA6EN;AA3EM;EAJF;IAKI,UAAA;EA8EN;AACF;AA5EM;EACE,WAAA;EACA,gBAAA;AA8ER;AA5EQ;EAJF;IAKI,cAAA;EA+ER;AACF;AA7EQ;EARF;IASI,eAAA;EAgFR;AACF;AA3EM;EACE,eAAA;AA6ER;AA1EI;EACE;IACE,WAAA;IACA,aAAA;EA4EN;AACF;AAxEE;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AA0EJ;AAxEI;EANF;IAOI,mBAAA;EA2EJ;AACF;AAzEI;EAVF;IAWI,mBAAA;EA4EJ;AACF;AA1EI;EAdF;IAeI,8BAAA;EA6EJ;AACF;AA3EI;EAlBF;IAmBI,eAAA;IACA,gCAAA;EA8EJ;AACF;AA3EE;EACE,oBAAA;EACA,kBAAA;AA6EJ;AA3EI;EAJF;IAKI,kBAAA;IACA,aAAA;EA8EJ;AACF;AA1EI;EADF;IAEI,WAAA;IACA,gBAAA;IACA,gBAAA;IACA,kBAAA;IACA,oBAAA;EA6EJ;AACF","sourcesContent":[":root {\n  --white: #ffffff;\n  --white-015: rgba(255, 255, 255, 0.15);\n  --black: #000000;\n  --black900: #080F16;\n  --lightkGray: #A4A4A4;\n  --gray: #879096;\n  --light-gray: rgba(130, 154, 181, 1);\n  --theme-dark: #162331;\n  --theme-secondary: #2c4158;\n  --theme-border: #25394F;\n  --secondry-border: rgba(255, 255, 255, 0.28);\n  --primaryBtn: #162331;\n  --primaryBtnHover: linear-gradient(to right, rgba(33, 168, 247, 1) 0%, rgba(53, 179, 249, 1) 100%);\n  --secondaryBtn: linear-gradient(to right, rgba(33, 168, 247, 1) 0%, rgba(53, 179, 249, 1) 100%);\n\n  --secondaryRadialBtn: linear-gradient(90deg, #F9E46D 0%, #C78C26 100%);\n\n  --secondaryRadialBtnLhover: linear-gradient(90deg, #C78C26 0%, #F9E46D 100%);\n\n  --secondaryBtnBorder: rgba(255, 255, 255, 0.45);\n  --primaryBtnBorder: #1B9FFB;\n  --authTabActiveBorder: #c69c53;\n  --headerBtnHover: #404D6A;\n  --placeBetBase: #0373b5;\n  --tipBtnBg: #26384B;\n  --authTabActiveBtnBg: #303F50;\n  --authTabBtn: #202F3F;\n  --moneTabsBtn: #26374A;\n  --authTabBtnText: #8A90A2;\n  --authSocailColor: #344051;\n  --authSocailTextColor: #6B758B;\n  --currencyHover: #1C2B3B;\n  --cryptoDetailsBtn: #587594;\n  --sidebarTooltip: #283C51;\n  --primaryGradient: linear-gradient(90deg, #283C51 0%, rgba(22, 35, 49, 0.00) 100%);\n  --detailsBorder: #283C52;\n  --inputbg: #121C27;\n  --inputBorder: #223244;\n  --chatModalBorder: #445d799b;\n  --chatModalClose: #2C3F54;\n  --weekBg: #1B2A39;\n  --themeCardTopGradient: linear-gradient(180deg, rgba(68, 94, 122, 1) 0%, rgba(37, 57, 79, 0)100%);\n  --themeCard: #213143;\n  --sidebarMenuBg: linear-gradient(180deg, #162331 0%, #1F3246 100%);\n  --liveMatchCountBg: linear-gradient(180deg, #273A4D 0%, #1A2835 100%);\n  --liveMatchCountBorder: rgba(255, 255, 255, 0.04);\n  --liveGreen: #72F238;\n  --profitBg: #2A3C2F;\n  --headingLink: #F9E46D;\n  --primaryBtnText: #B0E3FD;\n  --sidebarHover: #75cdff;\n  --inputBoxShadowOne: rgb(45 174 247);\n  --inputBoxShadowTwo: rgb(72 177 251);\n  --slider-btnBorder: #24364A;\n  --gameOnGradient: linear-gradient(180deg, #FFEBA9 0%, #E4B863 100%);\n  --loss: #FF3636;\n  --cryptoSellBtn: rgb(255, 73, 73);\n  --cryptoSellBtnBg: rgba(255, 73, 73, 0.13);\n  --cryptoSliderBg: linear-gradient(90deg, rgb(114, 242, 56) 0%, rgb(255, 176, 24) 50%, rgb(255, 73, 73) 100%);\n  --darkGray: #0F1923;\n  --table-fade: linear-gradient(to bottom, rgba(30, 87, 153, 0.01) 0%, rgba(15, 25, 35, 1) 100%);\n  --nft-badge: #223345;\n  --footerBorder: #323B45;\n  --cryptoDetailBtn: #263648;\n  --footerBg: #142230;\n  --selectBg: rgba(49, 58, 66, 0.50);\n  --footerLinking: #0F1B26;\n  --socialLinksBg: #1E2D3D;\n  --overlayBg: rgb(23 37 54 / 91%);\n  --webBannerOverlay: linear-gradient(90deg, #15222F -0.86%, rgba(15, 25, 35, 0.70) 18.12%, rgba(15, 25, 35, 0.00) 38.19%);\n  --authPrimryBtn: radial-gradient(90.91% 90.91% at 50.00% 9.09%, #1B2A3C 0%, #131F2D 100%);\n  --providerCard: linear-gradient(223deg, #162331 0%, #111D28 100%);\n  --profileMenuTop: #1E2F41;\n  --profileMenuBorder: #293C51;\n  --profileHover: #111C27;\n  --profileCard: #182533;\n  --profileCardBorder: #283A4E;\n  --statusColorOne: #BE6BFF;\n  --profileSocialBg: #1D2B3B;\n  --profileOutlineBtn: #080E14;\n  --cryptoText: #90B4D9;\n  --sidebarBtnGradient: linear-gradient(270deg, #0096FF -1.3%, #48BDFF 99.93%);\n  --loaderBg: rgb(15 25 35 / 85%);\n  --chatIcon: #829AB5;\n  --chatText: #AAB6CF;\n  --chatUserOne: #9F735C;\n  --chatCardBg: #283C5180;\n  --languagetext: #8A90A2;\n  --tipAmountText: #eb9b29;\n  --textGradientOne: linear-gradient(90deg, #526FFF 0%, #9CACFF 90.91%);\n  --textGradientTwo: linear-gradient(90deg, #36CAC5 0%, #8FFFEE 38.87%);\n  --textGradientThree: linear-gradient(270deg, #C776FF 8.01%, #A331F1 100%);\n  --ecosystemLinkOne: #5270FF;\n  --ecosystemLinkTwo: #3CCDC7;\n  --ecosystemLinkThree: #AE55ED;\n  --homePromotinBadge: #15212E;\n  --staticText: #636D82;\n  --listitemtext: #E7E7E7;\n  --dropdownShadow: 0px 0px 16px 0px #0F1923F5;\n  --cardBgBox: #1D2C3C;\n  --dragtextBg: #0F192366;\n  --userreportBg: #1f3140;\n  --previewBg: #283c51e0; // mine game variables\n  --rewardsBannerBg: rgb(23 37 54 / 75%);\n  --wildrange: #FF007A;\n  --sliderGradient: linear-gradient(90deg, #0493ED 0.9%, #810CFF 33.25%, #FD2E6E 100%);\n\n  --mineTableCellBg01: #32465C;\n  --mineTableCellBg02: #203041;\n  --mineTableCellCoinBg01: #182935;\n  --mineTableCellCoinBg02: #76C5FF;\n  --mineTableCellCoinBg03: #0068B4;\n  --mineTableCellMineBg01: #7976FF;\n  --mineTableCellMineBg02: #4F1AC1;\n  --mineTableCellBorder01: #49617C;\n  --mineTableCellBorder02: #3BABFC;\n  --mineTableCellBorder03: #793BFC;\n  --btnBgGreyHover: #3d5564;\n  --minePlachholder: #657D97;\n  --red: #FF0000;\n  --green: #00e701;\n  --themeGreyText: #30475F;\n\n  // keno game variables\n  --gameKenoSlenderBg: linear-gradient(rgba(20, 20, 20, 0.99), rgba(20, 20, 20, 0.99)),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.20) 0.95%, rgba(255, 255, 255, 0.01) 50%, rgba(255, 255, 255, 0.20) 100%);\n  --gameKenoNumberCell: linear-gradient(rgba(20, 20, 20, 0.99), rgba(20, 20, 20, 0.99)),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.25) 0.95%, rgba(255, 255, 255, 0.06) 50%, rgba(255, 255, 255, 0.25) 100%);\n  --gameKenoNumberGridBg: linear-gradient(rgba(20, 20, 20, 0.99), rgba(20, 20, 20, 0.99)),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.20) 0%, rgba(255, 255, 255, 0.20) 30%, rgba(255, 255, 255, 0.01) 50%, rgba(255, 255, 255, 0.20) 70%, rgba(255, 255, 255, 0.20) 100%);\n  --gameKenoNumberGridChangeBorder: linear-gradient(rgba(20, 20, 20, 0.99), rgba(20, 20, 20, 0.99)),\n    linear-gradient(133.45deg, #FFF1AB 24.75%, #FFDA24 46.17%, #FFC81D 54.03%, #FF9A0C 70.45%, #FF7700 81.88%);\n  --gameKenoNumberGridSelectedBg: linear-gradient(36.57deg, #FFFFFF 54.8%, #FBE9CF 97.25%), linear-gradient(0deg, #FFFFFF, #FFFFFF);\n  --kenoBtnShadow: 0px 9px 7.099999904632568px 0px #FFFFFF7A inset, 0px -2px 10px 0px #000000 inset, 0px 9px 7.099999904632568px 0px #FFFFFF7A inset, 0px -2px 10px 0px #000000 inset;\n  --kenoSelectedNumberShadow: 0px -4.182754039764404px 5.228443145751953px 0px #6C6C6C inset;\n  box-shadow: 0px 4.182754039764404px 4.182754039764404px 0px #00000040;\n\n  // plinko game variables\n  --riskBtnBg: #1B2938;\n  --riskBtnBorder: #213142;\n  --rangeSliderTrack: #23374C;\n\n  // flip-coin game variables\n  --flip-coin-text: rgba(34, 32, 32, 0.85);\n  --flip-coin-gradient: linear-gradient(93.45deg, #FF7A00 0%, #9CE800 139.58%);\n  --flip-coin-bg: radial-gradient(92.09% 85.42% at 86.3% 87.5%, rgba(0, 0, 0, 0.23) 0%, rgba(0, 0, 0, 0) 86.18%), #F6C100;\n\n\n  // Hi-lo game variables\n  --hoverBorder: #78CDFD;\n  --card-bg: #7EFF43;\n\n  // Game Color Pallete\n  --containerBg: #162331;\n\n  --containerBorder: #26384b;\n\n  --game-primary: #21A8F7;\n\n  --game-color-100: #111B26;\n  --game-color-200: #1F2E3E;\n  --game-color-300: #131D28;\n  --game-color-400: #26374A;\n  --game-color-500: #1B2938;\n  --game-color-600: #0F1923;\n  --game-color-700: #32465C;\n  --game-color-800: #203041;\n  --game-color-900: #151E28;\n\n  --game-text-100: #657D97;\n  --game-text-200: #90B4D9;\n  --game-text-300: #526C88;\n\n  --game-border-100: #25394F;\n  --game-border-200: #213142;\n  --game-border-300: #465D77;\n  --game-border-400: #212D3A;\n  --game-border-500: #30475F;\n\n  // Game Color coin fllip\n  --flip-coin-game-border: rgba(68, 94, 122, 0.5);\n  --range-slider-bg-800: #182534;\n  --flip-coin-checkbox-border: #192837;\n  --flip-coin-selctbox: #223346;\n  --flip-coin-addon-btn-bg: #1F2E3F;\n  --rangeSliderBg1: #0C8BEE;\n  --rangeSliderBg2: #F82C74;\n\n  // crash game\n\n  --black-700: #482E00;\n  --grey-700: #203143;\n}\n","@import \"../../assets/sass/_variables\";\n.home-sports-section {\n  padding-bottom: 1.875rem;\n\n  .theme-card-wrap {\n    transition: transform 0.15s ease-out 0s;\n\n    &:hover {\n      transform: translateY(-8px);\n    }\n  }\n\n  .slick-track {\n    padding: 0.625rem 0 0;\n  }\n\n  .theme-card {\n    text-align: center;\n    min-height: 156px;\n    cursor: pointer;\n\n    h4 {\n      color: var(--white);\n      font-weight: 700;\n      font-family: \"Teko\", sans-serif;\n      font-size: 1.125rem;\n      line-height: 1.25rem;\n    }\n\n    & svg {\n      margin: 1.5rem auto;\n      height: 36px !important;\n      width: 36px !important;\n    }\n\n    .live-game-icon {\n      margin: 1.5rem auto;\n    }\n  }\n\n  .live-match-count-wrap {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .live-match-count {\n    background: var(--liveMatchCountBg);\n    box-shadow: 0px 2px 5px 0px rgba(9, 27, 45, 0.47);\n    border-radius: 22px;\n    border: 1px solid var(--liveMatchCountBorder);\n    padding: 0 1rem;\n    min-height: 24px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    margin: 1rem auto 0;\n    color: var(--white);\n    position: absolute;\n    bottom: 1.5rem;\n\n    .live-dot {\n      background: var(--liveGreen);\n      height: 8px;\n      width: 8px;\n      border-radius: 100%;\n      display: block;\n      margin-right: 0.313rem;\n    }\n\n    p {\n      font-size: 0.875rem;\n      font-weight: 500;\n    }\n  }\n}\n\n.crypto-section {\n  padding-bottom: 1.875rem;\n\n  .theme-card-wrap {\n    transition: transform 0.15s ease-out 0s;\n    cursor: pointer;\n\n    .theme-card {\n      overflow: hidden;\n      min-height: 202px;\n      position: relative;\n\n      .trade-header {\n        padding: 0 0.625rem;\n\n        p {\n          font-size: 12px;\n          color: var(--authSocailTextColor);\n          font-weight: 600;\n          margin: 0;\n        }\n\n        .tarde-logo {\n          margin-right: 0.313rem;\n          height: 1.875rem;\n          width: 1.875rem;\n        }\n      }\n\n      .trade-card-content {\n        color: #ffffff;\n        padding: 0 0.625rem;\n\n        .crypto-list-right span {\n          font-size: 14px;\n          font-weight: 700;\n        }\n\n        h4 {\n          font-weight: 600;\n          margin: 0;\n          font-size: 0.875rem;\n        }\n      }\n\n      h4 {\n        color: var(--white);\n        font-size: 14px;\n        font-weight: 700;\n        margin: 0;\n      }\n\n      .tarde-graph-wrap {\n        position: absolute;\n        bottom: -20px;\n        width: 100%;\n\n        img {\n          width: 100%;\n          height: 100%;\n        }\n\n        .tarde-graph-text {\n          position: absolute;\n          left: 50%;\n          transform: translate(-50%, -50%);\n          bottom: 0.625rem;\n          width: 100%;\n\n          p {\n            color: var(--white);\n            font-size: 0.75rem;\n            font-weight: 400;\n            text-align: center;\n            padding: 0 0.313rem;\n          }\n        }\n      }\n    }\n\n    &:hover {\n      transform: translateY(-8px);\n    }\n  }\n\n  .loss-value {\n    color: var(--loss);\n    font-size: 0.75rem;\n    font-weight: 500;\n    margin: 0;\n\n    img {\n      margin-right: 0.313rem;\n    }\n  }\n\n  .profit-value {\n    color: var(--liveGreen);\n    font-size: 0.75rem;\n    font-weight: 500;\n    margin: 0;\n\n    img {\n      margin-right: 0.313rem;\n    }\n  }\n\n  .tarde-graph-text {\n    h4 {\n      font-weight: 300;\n      font-size: 0.75rem;\n    }\n\n    p {\n      font-weight: 400;\n      line-height: 0.75rem;\n    }\n  }\n\n  .slick-track {\n    padding: 0.625rem 0 0;\n  }\n\n  .Info-icon {\n    img {\n      width: 1rem;\n    }\n  }\n}\n\n.loss-change {\n  font-size: 12px;\n  font-weight: 600;\n  padding: 0 0.625rem;\n  color: var(--loss);\n}\n\n.profit-change {\n  font-size: 12px;\n  font-weight: 600;\n  padding: 0 0.625rem;\n  color: var(--liveGreen);\n}\n\n.slide-wrap {\n  .slick-slide {\n    .px-06 {\n      padding-right: 0.75rem;\n    }\n  }\n\n  .slick-list{\n    width: calc(100% + 10px);\n  }\n}\n.clutch-section {\n  padding-bottom: 1.875rem;\n\n  .clutch-header {\n    display: flex;\n    align-items: center;\n\n    img {\n      margin-right: 0.615rem;\n    }\n\n    h4 {\n      font-size: 1rem;\n      font-weight: 700;\n      text-transform: uppercase;\n      color: var(--white);\n    }\n  }\n\n  .slick-track {\n    padding: 0.625rem 0 0;\n  }\n\n  .theme-card-wrap {\n    cursor: pointer;\n    transition: transform 0.15s ease-out 0s;\n\n    .theme-card {\n      padding: 1.5rem;\n\n      @media screen and (max-width: 767.98px) {\n        padding: 1rem 0.625rem;\n      }\n\n      p {\n        color: var(--authTabBtnText);\n        font-size: 0.75rem;\n        font-weight: 400;\n        padding-top: 0.625rem;\n        line-height: 1rem;\n\n        @media screen and (max-width: 767.98px) {\n          padding-top: 0.313rem;\n        }\n      }\n\n      .clutch-card-content {\n        padding: 1rem 0 0;\n\n        h4 {\n          color: var(--white);\n          font-size: 0.813rem;\n          font-weight: 500;\n          line-height: 1rem;\n\n          a {\n            color: var(--authSocailTextColor);\n            font-size: 0.813rem;\n            font-weight: 400;\n          }\n        }\n\n        .clutch-card-content-left {\n          img {\n            margin-right: 0.625rem;\n          }\n        }\n\n        .btn-secondary {\n          font-size: 0.75rem;\n          height: 1.875rem;\n          min-width: 5.813rem;\n          border-radius: 0.5rem;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n        }\n      }\n    }\n\n    &:hover {\n      transform: translateY(-8px);\n    }\n  }\n}\n\n.poker-section {\n  padding-bottom: 1.875rem;\n\n  .theme-card-wrap {\n    cursor: pointer;\n    transition: transform 0.15s ease-out 0s;\n\n    .theme-card {\n      position: relative;\n      min-height: 200px;\n\n      &:before {\n        position: absolute;\n        content: \"\";\n        background: url(\"../../../public/assets/images/homePage/poker-overlay.png\");\n        height: 100%;\n        width: 100%;\n        top: 0;\n        left: 0;\n        background-repeat: no-repeat;\n        background-size: cover;\n      }\n\n      h4 {\n        color: var(--white);\n        font-weight: 700;\n        font-family: \"Teko\", sans-serif;\n        font-size: 1.2rem;\n        line-height: 1.8rem;\n        text-align: center;\n        margin: 0;\n\n        @media (min-width: 992px) and (max-width: 1199.98px) {\n          font-size: 1.2rem;\n        }\n      }\n\n      p {\n        text-align: center;\n        color: var(--authTabBtnText);\n        font-size: 0.75rem;\n        margin: 0;\n      }\n\n      .poker-card-content {\n        position: relative;\n\n        .poker-icon {\n          height: 120px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n        }\n\n        img {\n          margin: 0 auto;\n        }\n      }\n    }\n\n    &:hover {\n      transform: translateY(-8px);\n    }\n  }\n\n  .slick-track {\n    padding: 0.625rem 0 0;\n  }\n}\n\n.nft-section {\n  padding-bottom: 1.875rem;\n\n  .theme-card-wrap {\n    cursor: pointer;\n    transition: transform 0.15s ease-out 0s;\n\n    .theme-card {\n      .nft-img-wrap {\n        position: relative;\n        overflow: hidden;\n        border-radius: 0.625rem;\n\n        img {\n          width: 100%;\n        }\n\n        .nft-badge {\n          position: absolute;\n          padding: 0 0.313rem;\n          border-radius: 27px;\n          background: var(--nft-badge);\n          min-height: 26px;\n          min-width: 40px;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          color: var(--white);\n          font-size: 0.625rem;\n          font-weight: 600;\n          left: 0.313rem;\n          top: 0.313rem;\n        }\n      }\n\n      .nft-content-wrap {\n        padding: 0.313rem 0;\n\n        .nft-content-left {\n          h4 {\n            color: var(--white);\n            font-size: 1rem;\n            font-weight: 600;\n          }\n\n          p {\n            color: var(--authTabBtnText);\n            margin: 0;\n            font-size: 0.875rem;\n          }\n        }\n\n        .nft-content-right {\n          span {\n            color: var(--authTabBtnText);\n            font-size: 0.75rem;\n          }\n        }\n      }\n    }\n\n    &:hover {\n      transform: translateY(-8px);\n    }\n  }\n\n  .slick-track {\n    padding: 0.625rem 0 0;\n  }\n}\n\n.crypto-won-section {\n  padding-bottom: 1.5rem;\n  text-align: center;\n\n  .payment-options {\n\n    // position: absolute;\n    // transform: translate(-50%, -50%);\n    // left: 50%;\n    // top: 50%;\n    // @media screen and (max-width: 1199.98px) {\n    //   position: static;\n    //   transform: none;\n    //   display: flex;\n    //   justify-content: center;\n    //   flex-wrap: wrap;\n    //   margin: 0.625rem 0;\n    // }\n    a {\n      padding: 0 0.625rem;\n      display: inline-block;\n\n      @media screen and (max-width: 767.98px) {\n        padding: 0;\n      }\n\n      img {\n        width: auto;\n        height: 1.813rem;\n\n        @media screen and (max-width: 1399.98px) {\n          height: 1.5rem;\n        }\n\n        @media screen and (max-width: 767.98px) {\n          height: 1.25rem;\n        }\n      }\n    }\n\n    &.flexible-section {\n      a {\n        padding: 0 1rem;\n      }\n    }\n    @media screen and (max-width: 767.98px) {\n      svg,img {\n        width: 45px;\n        margin: 0 3px;\n      }\n    }\n  }\n\n  h3 {\n    color: var(--white);\n    font-size: 1.25rem;\n    line-height: 1.5rem;\n    font-weight: 700;\n\n    @media screen and (max-width: 1399.98px) {\n      font-size: 1.125rem;\n    }\n\n    @media screen and (max-width: 1199.98px) {\n      font-size: 1.125rem;\n    }\n\n    @media screen and (max-width: 991.98px) {\n      margin-bottom: 1rem !important;\n    }\n\n    @media screen and (max-width: 767.98px) {\n      font-size: 1rem;\n      margin-bottom: 0.5rem !important;\n    }\n  }\n\n  .theme-card {\n    padding: 0.3rem 2rem;\n    position: relative;\n\n    @media screen and (max-width: 767.98px) {\n      text-align: center;\n      padding: 1rem;\n    }\n  }\n\n  .btn-secondary {\n    @media screen and (max-width: 767.98px) {\n      width: 100%;\n      min-width: 100px;\n      min-height: 40px;\n      font-size: 0.75rem;\n      margin-top: 0.625rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
